import { useEffect, useState } from "react"

interface Countdown {
    dias: string
    horas: string
    minutos: string
    segundos: string
    progresso?: number
}

export function useCountdown(dataFim: string | null, dataInicio?: string | null): Countdown {
    const [tempoRestante, setTempoRestante] = useState<Countdown>({
        dias: "00",
        horas: "00",
        minutos: "00",
        segundos: "00",
        progresso: 0,
    })

    useEffect(() => {
        if (!dataFim) return

        const fim = new Date(dataFim)
        const inicio = dataInicio ? new Date(dataInicio) : null
        const total = inicio ? fim.getTime() - inicio.getTime() : null

        const atualizarContador = () => {
            const agora = new Date()
            const diff = fim.getTime() - agora.getTime()

            if (diff <= 0) {
                setTempoRestante({ dias: "00", horas: "00", minutos: "00", segundos: "00", progresso: 100, })
                return
            }

            const dias = Math.floor(diff / (1000 * 60 * 60 * 24))
            const horas = Math.floor((diff / (1000 * 60 * 60)) % 24)
            const minutos = Math.floor((diff / (1000 * 60)) % 60)
            const segundos = Math.floor((diff / 1000) % 60)

            let progresso: number | undefined = undefined
            if (inicio && total && total > 0) {
                const perc = ((agora.getTime() - inicio.getTime()) / total) * 100
                progresso = Math.min(Math.max(perc, 0), 100) // clamp 0–100
            }

            setTempoRestante({
                dias: String(dias).padStart(2, "0"),
                horas: String(horas).padStart(2, "0"),
                minutos: String(minutos).padStart(2, "0"),
                segundos: String(segundos).padStart(2, "0"),
                progresso,
            })
        }

        const interval = setInterval(atualizarContador, 1000)
        atualizarContador()

        return () => clearInterval(interval)
    }, [dataFim, dataInicio])

    return tempoRestante
}
